import { createSlice } from '@reduxjs/toolkit';

import {
  scmType
} from 'helpers';

import {
  serviceGetProject,
  serviceGetCompanies,
  servicePostProject,
  servicePutProject,
  serviceDeleteProject,
  serviceSyncProject,
  serviceGetCredentials,
} from 'utils';


const initialState = {
  data: null,
  fieldDataConst: {
    scmType
  },
  fieldData: {
    companies: [],
    credentials: [],
  },
  isLoaded: {
    fieldData: false,
    post: false,
    put: false,
    delete: false,
    get: false,
    sync: false,
  },
  success: {
    fieldData: false,
    post: false,
    put: false,
    delete: false,
    get: false,
    sync: false,
  },
  error: {
    fieldData: false,
    post: false,
    put: false,
    delete: false,
    get: false,
    sync: false,
  },
}

const ProjectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {

    getFieldDataSuccess(state, action) {
      const data = action.payload;
      const companies = [
        ...data.companies.map((i) => ({ value: i.company_id, label: i.name })),
      ];
      const credentials = [
        ...data.credentials.map((i) => ({ value: i.credential_id, label: i.name })),
      ];

      return {
        ...state,
        isLoaded: { ...state.isLoaded, fieldData: false },
        fieldData: {
          companies,
          credentials
        },
      };
    },


    getFieldDataRequest(state, action) {
      return { ...state, isLoaded: { ...state.isLoaded, fieldData: true } };
    },

    getFieldDataFailure(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, fieldData: false },
        error: { ...state.error, fieldData: action.payload.message },
      };
    },

    dataRequest(state, action) {
      return { ...state, isLoaded: { ...state.isLoaded, [action.payload]: true } };
    },

    dataSuccess(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        success: { ...state.success, [action.payload.fetchType]: true },
        data: action.payload.data || null,
      };
    },

    dataFailure(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        error: { ...state.error, [action.payload.fetchType]: action.payload.data?.message },
      };
    },

    cleanUpProject() {
      return initialState;
    },

    cleanUpDataFieldProject(state) {
      return {
        ...state,
        fieldData: {
          companies: [],
          credentials: [],
        },
      };
    },

    cleanUpMessageProject(state) {
      return {
        ...state,
        data: null,
        isLoaded: initialState.isLoaded,
        success: initialState.success,
        error: initialState.error,
      };
    },

  }
});

const {
  getFieldDataSuccess,
  getFieldDataRequest,
  getFieldDataFailure,
  dataRequest,
  dataSuccess,
  dataFailure,
  cleanUpProject,
  cleanUpDataFieldProject,
  cleanUpMessageProject
} = ProjectSlice.actions;

const fetchGetFieldData = () => {
  return (dispatch) => {
    dispatch(cleanUpDataFieldProject());
    dispatch(getFieldDataRequest());
    Promise.all([serviceGetCompanies({}), serviceGetCredentials({})])
      .then((responses) => {
        const companies = responses[0].data;
        const credentials = responses[1].data;
        dispatch(getFieldDataSuccess({ companies, credentials }));
      })
      .catch((err) => dispatch(getFieldDataFailure(err)));
  };
};

const fetchGetProject = (query) => {
  return (dispatch) => {
    dispatch(dataRequest('get'));
    serviceGetProject(query)
      .then((response) => dispatch(dataSuccess({data: response.data[0], fetchType: 'get'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'get'})));
  };
};

const fetchPostProject = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('post'));
    servicePostProject(body)
      .then((response) => {
        if (response.data.result === 1){
          dispatch(dataSuccess({data: response.data, fetchType: 'post'}));
        }else{
          dispatch(dataFailure({data: {message:response.data.result}, fetchType: 'post'}));
        }
      })
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'post'})));
  };
};

const fetchPutProject = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('put'));
    servicePutProject(body)
      .then((response) => {
        if (response.data.result === 1){
          dispatch(dataSuccess({data: response.data, fetchType: 'put'}))
        }else{
          dispatch(dataFailure({data: {message:response.data.result}, fetchType: 'put'}))
        }
      })
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'put'})));
  };
};

const fetchDeleteProject = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('delete'));
    serviceDeleteProject(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'delete'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'delete'})));
  };
};

const fetchSyncProject = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('sync'));
    serviceSyncProject(body)
      .then((response) => {
         if (response.data.result === 1){
            dispatch(dataSuccess({data: response.data, fetchType: 'sync'}));
         } else {
            dispatch(dataFailure({data: {message: response.data.result}, fetchType: 'sync'}));
         }
      })
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'sync'})));
  };
};

export {
  fetchGetFieldData,
  fetchGetProject,
  fetchPostProject,
  fetchPutProject,
  fetchDeleteProject,
  fetchSyncProject,
  cleanUpProject,
  cleanUpMessageProject,
  cleanUpDataFieldProject
};

export default ProjectSlice.reducer;
